export default {
    Get: {
    },
    Set: {
        SET_LIST_OF_ARCHITECTURE: 'setListOfArchitecture',
        SET_LIST_OF_USAGE: 'setListOfUsage',
        SET_LIST_OF_EXTERIOR_STATE: 'setListOfExteriorState',
        SET_LIST_OF_INTRIOR_DECOR: 'setListOfIntriorDecor',
        DELETE_LIST_OF_ARCHITECTURE: 'deleteListOfArchitecture',
        ADD_LIST_OF_ARCHITECTURE: 'addListOfArchitecture',
        UPDATE_LIST_OF_ARCHITECTURE: 'updateListOfArchitecture',
        HANDLE_SELECT_LIST_OF_USAGE: 'handleSelectListOfUsage',
        HANDLE_SELECT_LIST_OF_INTERIOR_DECOR: 'handleSelectListOfInteriorDecor',
        HANDLE_SELECT_LIST_OF_EXTERIOR_STATE: 'handleSelectListOfExteriorState',
        HANDLE_SELECT_LIST_OF_ARCHITECTURE: 'handleSelectListOfArchitecture',
    }
};